import { createContext, ReactNode, useState, useEffect } from "react";

export type IHeaderContext = {
	isComingSoonEnabled: boolean;
	isComingSoonOpen: boolean;
	setIsComingSoonOpen: (value: boolean) => void;
};

type IProps = {
	children: ReactNode;
};

export const HeaderContext = createContext<IHeaderContext>(undefined!);

export function HeaderProvider(props: IProps) {
	// const isComingSoonWasClosed: boolean = !!~~(localStorage.getItem("isComingSoonWasClosed") ?? "0");
	const [isComingSoonOpen, setIsComingSoonOpen] = useState<boolean>(true);

	useEffect(() => {
		let isComingSoonWasClosed = !isComingSoonOpen;
		localStorage.setItem("isComingSoonWasClosed", isComingSoonWasClosed ? "1" : "0");
	}, [isComingSoonOpen]);

	return (
		<HeaderContext.Provider
			value={{
				isComingSoonEnabled: false,
				isComingSoonOpen,
				setIsComingSoonOpen,
			}}>
			{props.children}
		</HeaderContext.Provider>
	);
}
